import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheIngenieurDevOps = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          ⚙️ Recruter un Ingénieur DevOps
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          L’Ingénieur DevOps assure le lien entre le développement et l’exploitation des applications. Son objectif : automatiser, fiabiliser et accélérer les cycles de déploiement. Il met en place des outils d’intégration et de livraison continues (CI/CD), garantit la scalabilité des environnements, et optimise les workflows pour une livraison logicielle fluide et continue.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Concevoir et gérer les pipelines CI/CD (build, test, déploiement)</li>
          <li>Automatiser la gestion des infrastructures (Infrastructure as Code)</li>
          <li>Superviser les environnements de production et de pré-production</li>
          <li>Intégrer des outils de monitoring, logging, alerting</li>
          <li>Sécuriser les flux, les accès et les données</li>
          <li>Collaborer avec les développeurs, ingénieurs cloud et sécurité</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Outils CI/CD : Jenkins, GitLab CI, GitHub Actions, CircleCI</li>
          <li>IaC : Terraform, Ansible, CloudFormation</li>
          <li>Conteneurs : Docker, Kubernetes</li>
          <li>Environnements : Linux, cloud (AWS, Azure, GCP)</li>
          <li>Scripting : Bash, Python, YAML</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : gestion d’environnements simples, support CI/CD</li>
          <li>Confirmé : automatisation complète, bonnes pratiques DevOps</li>
          <li>Senior / SRE : scalabilité, haute disponibilité, sécurité avancée, culture SRE</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior / SRE : 750–1 000 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheIngenieurDevOps;
